import React from "react";
import ReactDOM from "react-dom/client";
import {HelmetProvider} from "react-helmet-async";
//
import "rc-slider/assets/index.css";
// STYLE
import "./styles/index.scss";
import "./index.css";
import "./fonts/line-awesome-1.3.0/css/line-awesome.css";

//
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import {Provider} from "react-redux";
import {store} from "store/store";
import {AuthProvider} from "./contexts/AuthContext";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
// 👇 Silenciar console.* solo en producción
if (process.env.NODE_ENV === "production") {
  console.log = function () {};
  console.error = function () {};
  console.debug = function () {};
}
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <HelmetProvider>
      {/* <APIProvider apiKey={process.env.REACT_APP_GOOGLE_MAP_API_KEY || ""}> */}
      <AuthProvider>
        <App />
      </AuthProvider>
      {/* </APIProvider> */}
    </HelmetProvider>
  </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
